import { apiClient, unwrap } from './client';
import type { Filiale } from '@/types';

/** Une société à laquelle la personne connectée est rattachée (sélecteur de société, lot 1 étape 1.7). */
export interface MaSociete {
  filialeKey:   string;
  name:         string;
  fullName:     string;
  metierLabel:  string;
  statut:       'active' | 'dormante';
  /** Société d'origine du compte. */
  origine:      boolean;
  /** Ouvrable aujourd'hui (une dormante ne l'est pas). */
  ouvrable:     boolean;
  colorPrimary: string;
  logoPath:     string;
}

export const filialesApi = {
  /** Config de la filiale du user connecté + métier dynamique + couleurs brand */
  getMe: async (): Promise<Filiale> => {
    const res = await apiClient.get('/filiales/me');
    return unwrap<Filiale>(res);
  },

  /** Sociétés auxquelles la personne est rattachée (liste identique quelle que soit la société ouverte). */
  mesSocietes: async (): Promise<MaSociete[]> => {
    const res = await apiClient.get('/filiales/mes-societes');
    return unwrap<MaSociete[]>(res);
  },
};
